<template>
    <div>
        <my_menu2 page_name="PDF压缩" back_type="close" back_icon="md-close"></my_menu2>
        <div style="height:40px"></div>
        <div class='div2'>
            <div class="upload_div">
                <div class="radio_div">
                    <RadioGroup v-model="quality_type" type="button" button-style="solid" @on-change="radio_change">
                        <Radio label="低级压缩"></Radio>
                        <Radio label="标准压缩"></Radio>
                        <Radio label="较高压缩"></Radio>
                        <Radio label="最高压缩"></Radio>
                    </RadioGroup>
                    <div class="yasuo_txt">
                        说明：压缩级别越高，压缩后文件越小，但可能会导致文件模糊
                    </div>
                </div>
                <div class="upload_btn2">
                    <Upload v-if="upload_show" :action="upload_url" :on-success="file_success" ref="upload"
                        :on-progress="file_progress">
                        <Button :loading="loading" type="primary" icon="ios-cloud-upload-outline">选择PDF文件开始压缩</Button>
                    </Upload>
                </div>
                <div v-if="this.upload_item.object_name" class="success_div">
                    <div>原文件大小：{{ this.upload_item.input_file_size }}</div>
                    <div>压缩后文件大小：{{ this.upload_item.output_file_size }}<Button size="small"
                            style="font-size: 13px;margin-left:20px" @click="down_file">
                            <Icon type="ios-cloud-download-outline" />下载或预览压缩后文件
                        </Button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
export default {
    components: {
        my_menu2,
    },
    data() {


        return {
            quality_type: '较高压缩',
            loading: false,
            upload_item: {
                'input_file_size': '',
                'output_file_size': '',
                'url': '',
                'suffix': '',
                'object_name': ''
            },
            quality_type_dict: {
                '低级压缩': 1,
                '标准压缩': 2,
                '较高压缩': 3,
                '最高压缩': 4,
            },
            upload_show: true,
            upload_url:
                process.env.VUE_APP_HOST +
                "/tools/compress/compress_pdf?token=" +
                this.$cookies.get("dx_token")
        }
    },
    mounted() {
        this.upload_url = process.env.VUE_APP_HOST +
            "/tools/compress/compress_pdf?token=" +
            this.$cookies.get("dx_token") + '&quality_type=' + this.quality_type_dict[this.quality_type]
    },
    methods: {

        down_file() {
            get_view_file_url(this.upload_item.object_name)
        },
        radio_change() {
            this.upload_show = false
            this.upload_url = process.env.VUE_APP_HOST +
                "/tools/compress/compress_pdf?token=" +
                this.$cookies.get("dx_token") + '&quality_type=' + this.quality_type_dict[this.quality_type]
            this.upload_show = true
        },
        file_progress() {
            this.upload_item = {
                'input_file_size': '',
                'output_file_size': '',
                'url': '',
                'suffix': '',
                'object_name': ''
            }
            this.loading = true
        },
        file_success(e) {
            console.log(e)
            if (e.code == 0) {
                this.$Message.success(e.msg)
                this.upload_item = e.data
            } else {
                this.$refs.upload.clearFiles()
                this.$Message.error(e.msg)
            }

            this.loading = false

        }
    }
}
</script>

<style scoped>
.success_div {
    padding: 10px;
    margin-top: 20px;
    border: 1px solid #ccc;
    background-color: rgb(119, 223, 126);
}

.upload_btn2{
    display: flex;
    justify-content: center;
}

.div2 {
    display: flex;
    justify-content: center;
}

.radio_div {
    margin-top: 10px;
    margin-bottom: 20px;
}

.yasuo_txt {
    font-size: 13px;
    color: #777777;
}

.upload_div {
    padding: 20px;
}
</style>